// Shared status filter chip for the grids' multi-select filter rows. Each chip
// is an independent toggle; the "All" chip clears the set. Extracted from
// LegacyChats.tsx when Discovery Calls grew the same filter row.

export default function FilterChip({
  label,
  active,
  onClick,
  tone,
}: {
  label: string;
  active: boolean;
  onClick: () => void;
  tone?: string;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      className={[
        'rounded-full border px-3 py-1 text-xs font-bold uppercase tracking-wide transition',
        active
          ? `border-transparent ${tone ?? 'bg-brand-lime text-brand-forest'} shadow-sm`
          : 'border-brand-sage/40 bg-white text-brand-forest hover:border-brand-lime hover:text-brand-lime-700',
      ].join(' ')}
    >
      {label}
    </button>
  );
}